import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=440179cf"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"
import style0 from "./pagination.vue?vue&type=style&index=0&id=440179cf&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('440179cf')) {
      api.createRecord('440179cf', component.options)
    } else {
      api.reload('440179cf', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=440179cf", function () {
      api.rerender('440179cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pagination/pagination.vue"
export default component.exports